import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { useCurrentUser } from '@/shared/auth/hooks';

import { pushKeys, usePushConfig } from './api';
import { syncDevicePush } from './device';

/**
 * Renders nothing; at every start of the signed-in portal (and whenever another account signs in on this browser) it registers
 * this browser's push subscription again when push is on here — so the device follows the account and a lost or replaced
 * subscription is repaired without the user doing anything.
 */
export function PushSync() {
  const user = useCurrentUser();
  const config = usePushConfig();
  const queryClient = useQueryClient();
  const settings = config.data;

  useEffect(() => {
    if (!settings?.enabled) return;
    syncDevicePush(settings).then(
      (registered) => {
        if (registered) void queryClient.invalidateQueries({ queryKey: pushKeys.devices });
      },
      (error: unknown) => {
        console.warn('Push could not be registered on this device', error);
      },
    );
  }, [settings, user.id, queryClient]);

  return null;
}
